var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2199 0.387183C14.5639 0.692948 14.5949 1.21967 14.2892 1.56366L5.40026 11.5637C5.24212 11.7416 5.01545 11.8434 4.77741 11.8434C4.53938 11.8434 4.31271 11.7416 4.15457 11.5637L0.263681 8.01983C-0.0420838 7.67584 -0.0110999 7.14911 0.332886 6.84335C0.676871 6.53758 1.2036 6.56857 1.50936 6.91255L4.77741 9.75569L13.0435 0.456387C13.3492 0.112402 13.876 0.0814177 14.2199 0.387183Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCheck);
export default __webpack_public_path__ + "static/media/BlackCheck.e8d901e3efcef8f12ad682032ed83ed5.svg";
export { ForwardRef as ReactComponent };